"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.isUnique=isUnique;/**
 * Checks if the selector is unique
 * @param  { Object } element
 * @param  { String } selector
 * @return { Array }
 */function isUnique(el,selector){if(!Boolean(selector))return false;var elems=el.ownerDocument.querySelectorAll(selector);return elems.length===1&&elems[0]===el;}